const percent = 100;

const extractRecommendationQuestions = (forms) =>
	forms.reduce((acc, form) => {
		const recommendationQuestion = form.questions.find(
			(question) =>
				question.fieldType.toLowerCase() === 'recommendations' &&
				Number(question.recommendationQuestionNumber) === 1,
		);

		if (recommendationQuestion) {
			acc.push({
				formName: form.formName,
				recommendationQuestion: {
					label: recommendationQuestion.label,
					responses: recommendationQuestion.responses.map((response) => ({
						interviewerName: response.interviewerName,
						answerValue: response.answerValue,
					})),
				},
			});
		}

		return acc;
	}, []);

const calculateRecommendationCounts = (forms) =>
	forms.map(({ formName, recommendationQuestion }) => {
		const recommendedCount = recommendationQuestion.responses.filter(
			(response) => Number(response.answerValue) === 2,
		).length;
		const totalCount = recommendationQuestion.responses.length;

		return {
			formName,
			recommendedCount,
			totalCount,
		};
	});

const calculateRecommendationPercentage = (data) => {
	const totals = data.reduce(
		(acc, { recommendedCount, totalCount }) => {
			acc.totalRecommended += recommendedCount;
			acc.totalQuestions += totalCount;
			return acc;
		},
		{ totalRecommended: 0, totalQuestions: 0 },
	);

	return Math.round((totals.totalRecommended / totals.totalQuestions) * percent);
};

export const getRecommendationStatus = (data) => {
	const percentage = calculateRecommendationPercentage(data);

	if (percentage === 0) {
		return { text: 'not_recommended', deg: '180deg' };
	}
	if (percentage === percent) {
		return { text: 'recommended', deg: '0deg' };
	}
	return { text: 'mixed_opinions', deg: '270deg' };
};

const getRecommendationQuestion = (data) => {
	const recommendationQuestions = extractRecommendationQuestions(data);
	return calculateRecommendationCounts(recommendationQuestions);
};

export const getFeedbackWithSummary = (data) => {
	const recommendations = getRecommendationQuestion(data.summary.formDetails);

	return {
		feedbacks: data.feedback
			.slice()
			.sort((a, b) => new Date(b.requestedOn) - new Date(a.requestedOn)),
		summary: {
			...data.summary,
			recommendations,
			recommendationStatus: getRecommendationStatus(recommendations),
			noData: data.summary.ratings.length === 0 && recommendations.length === 0,
		},
	};
};

export const getFeedbackDetailedSummary = (data) => {
	const recommendations = extractRecommendationQuestions(data.formDetails);

	return {
		...data,
		recommendations,
		noData: data.ratings.length === 0 && recommendations.length === 0,
	};
};
